export interface Supplier {
  id?: string;
  personType: number | string;
  name: string;
  cpfCnpj: string;
  gender: string;
  contractType: string;
  picture: string;
  // user fields (flattened)
  userId?: string;
  username: string;
  email: string;
  roles: string[];
  // address fields (flattened)
  cep: string;
  city: string;
  streetName: string;
  complement: string;
  neighborhood: string;
  uf: string;
  // contact fields (flattened)
  phone: string;
  cellphone: string;
  // office fields (flattened)
  officeId: string;
  officeName: string;
  // responsibility fields (flattened)
  responsibilityId: string;
  responsibilityName: string;
  accessType: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
}

export interface SupplierRequest {
  name: string;
  cpfCnpj: string;
  contractType: ContractType;
  personType: PersonType;
  officeId: string;
  responsibilityId: string;
  supervisorId: string;
  managerId: string;
  accessType: string;
  username: string;
  email: string;
  password: string;
  roles: string[];
}

export enum ContractType {
  CLT = "Clt",
  PROFESSIONAL = "Autônomo",
  SUPPLIER = "Prestador de Serviço",
}

export enum PersonType {
  USER = "Profissional",
  SUPERVISOR = "Supervisor",
  MANAGER = "Gerente",
}
